/**
 * Aligne un <linearGradient> SVG sur un équivalent CSS linear-gradient().
 *
 * - Angle CSS : 0° = vers le haut, sens horaire (comme Figma / navigateurs).
 * - Coordonnées en unités objectBoundingBox (pourcentages du viewBox de la forme).
 *
 * Les pourcentages de stops Figma (ex. -0.12% et 110.86%) sont relatifs à la ligne
 * allant du point CSS 0% au point CSS 100% (traversée du cadre). Les étendre
 * recrée le même étirement du mélange que dans la maquette.
 */

/** Ligne du dégradé CSS entre le point 0% et 100% (repère haut = 0°). */
function cssAngleToGradientLineEndpoints(angleDeg: number): {
  sx: number;
  sy: number;
  ex: number;
  ey: number;
} {
  const rad = (angleDeg * Math.PI) / 180;
  const ux = Math.sin(rad);
  const uy = -Math.cos(rad);
  return {
    sx: 0.5 - 0.5 * ux,
    sy: 0.5 - 0.5 * uy,
    ex: 0.5 + 0.5 * ux,
    ey: 0.5 + 0.5 * uy,
  };
}

export function cssLinearGradientStopsToSvgObjectBoundingBox(
  angleDeg: number,
  /** Ex. -0.12 pour -0.12% */
  cssStopStartPercent: number,
  /** Ex. 110.86 pour 110.86% */
  cssStopEndPercent: number,
): { x1: string; y1: string; x2: string; y2: string } {
  const { sx, sy, ex, ey } = cssAngleToGradientLineEndpoints(angleDeg);
  const vx = ex - sx;
  const vy = ey - sy;
  const t0 = cssStopStartPercent / 100;
  const t1 = cssStopEndPercent / 100;
  const x1 = sx + t0 * vx;
  const y1 = sy + t0 * vy;
  const x2 = sx + t1 * vx;
  const y2 = sy + t1 * vy;
  return {
    x1: `${x1 * 100}%`,
    y1: `${y1 * 100}%`,
    x2: `${x2 * 100}%`,
    y2: `${y2 * 100}%`,
  };
}
